import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  setup: null,
  cards: [],
  lastPayment: null,
};

export const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {
    setSetup: (state, action) => {
      state.setup = action.payload;
    },
    setCards: (state, action) => {
      state.cards = action.payload;
    },
    setLastPayment: (state, action) => {
      state.lastPayment = action.payload;
    },
  },
});

export const { setSetup, setCards, setLastPayment } = billingSlice.actions;

export default billingSlice.reducer;
